import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./GivingFormLauncher";

export const withStore = (props) => {
  const store = ReactOnRails.getStore("GivingFormStore");

  return (
    <Provider store={store}>
      <BrowserRouter>
        <App {...props} />
      </BrowserRouter>
    </Provider>
  );
};

export default withStore;
